export const RESET_ROUTE_PATH = '/latest';
export const RETURN_URL_PARAM = 'return';
export const DEFAULT_RESTORE_PATH = '/';
